enum ReportsStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description sales report per sector
   */
  GetReports = "/v2/admin/reports/sales-per-sector",
  GetDate = "/v2/admin/reports/list-by-date",
  GetReportsMonthly = "/v2/admin/reports/monthly-closure",
  GetReportsMonthlyExport = "/v2/admin/reports/monthly-closure-export",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Coutries
   */
  reportAgencies = "/v2/agencies/report",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Coutries
   */
  reportClients = "/v2/admin/clients/report",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Coutries
   */
  reportProperty = "/v2/admin/realestates/report",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Coutries
   */
  extendReportPropertyDowload = "/v2/admin/realestates/extended-report",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Coutries
   */
  extendReportProperty = "/v2/admin/realestates/extended-report",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Users report
   */
  reportUser = "v2/users/export",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Commission report
   */
  reportCommission = "v2/admin/reports/commissions",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get Commission report group
   */
  reportCommissionGroup = "v2/admin/reports/commissions-grouped"
}

const ReportsDinamic = {};

export const ReportsEndpoints = {
  ...ReportsStatic,
  ...ReportsDinamic
};

export type ReportsEndpoints = typeof ReportsEndpoints;

// power by mouseinyl
